import { getNativeRcxCookie } from '../../lib/Cookies/RcxCookie';
import { getNativeRzCookie } from '../../lib/Cookies/RzCookie';
import { TrackAppHit, TrackAppAppear, TrackAppClick } from '../../lib/RAT';
import {
	PostHitEvent,
	PostAppearEvent,
	PostClickEvent,
} from '../../lib/REST/ApiTracking';
import { getLocation } from '../../lib/REST/utils';
import { WebBlocksApiBlockT } from '../../lib/REST/types';

type BaseTrackingType = {
	campaignId: string;
	contentId: string;
	ratAccountId: string;
	ratServiceType: string;
	isMobile: boolean;
	environment: string;
	clientId: string;
	sessionId: string;
	previewQuery?: object;
};

type OnRenderedType = BaseTrackingType & {
	onBlockLoad: (selector: string) => void;
	selector?: string | null;
};

type OnLinkClickType = BaseTrackingType & {
	url: string;
};

export function getCreatePortalKey({
	contentId = '',
	campaignId = '',
	selector = '',
}: {
	contentId: string;
	campaignId: string;
	selector?: string | null;
}) {
	return `${contentId}-${campaignId}-${selector}`;
}

const MOBILE_SCREEN_MAX_WIDTH = 768;

function isScreenMobile() {
	return window.innerWidth <= MOBILE_SCREEN_MAX_WIDTH;
}

export function getMainAppInfo() {
	return {
		sessionId: getNativeRcxCookie(),
		isMobile: isScreenMobile(),
		location: getLocation(),
		userId: getNativeRzCookie(),
	};
}

export function onRendered({
	onBlockLoad = () => {},
	selector,
	campaignId = '',
	contentId = '',
	ratAccountId = '',
	ratServiceType = '',
	isMobile = false,
	previewQuery = {},
	environment = '',
	clientId = '',
	sessionId = '',
}: OnRenderedType) {
	if (selector) {
		onBlockLoad(selector);
	}

	TrackAppHit({
		campaignId,
		contentId,
		ratAccountId,
		ratServiceType,
		isMobile,
		trackCb: () =>
			PostHitEvent({
				apiEnv: environment,
				clientId,
				sessionId,
				campaignId,
				contentId,
				previewQuery,
			}),
	});
}

export function onAppear({
	campaignId = '',
	contentId = '',
	ratAccountId = '',
	ratServiceType = '',
	isMobile = false,
	previewQuery = {},
	environment = '',
	clientId = '',
	sessionId = '',
}: BaseTrackingType) {
	TrackAppAppear({
		campaignId,
		contentId,
		ratAccountId,
		ratServiceType,
		isMobile,
		trackCb: () =>
			PostAppearEvent({
				apiEnv: environment,
				clientId,
				sessionId,
				campaignId,
				contentId,
				previewQuery,
			}),
	});
}

export function onLinkClick({
	campaignId = '',
	contentId = '',
	ratAccountId = '',
	ratServiceType = '',
	isMobile = false,
	previewQuery = {},
	environment = '',
	clientId = '',
	sessionId = '',
	url = '',
}: OnLinkClickType) {
	return TrackAppClick({
		campaignId,
		contentId,
		ratAccountId,
		ratServiceType,
		isMobile,
		url,
		trackCb: () =>
			PostClickEvent({
				apiEnv: environment,
				clientId,
				sessionId,
				campaignId,
				contentId,
				url,
				previewQuery,
			}),
	});
}

export function filterDuplicates({
	blocks = [],
}: {
	blocks: WebBlocksApiBlockT[] | undefined;
}) {
	if (blocks === undefined) {
		return [];
	}

	const mySet = new Set<string>();
	const output: WebBlocksApiBlockT[] = [];
	for (let i = 0; i < blocks.length; i += 1) {
		const block = blocks[i];
		const { selector } = block;
		if (!selector) {
			output.push(block);
		} else if (!mySet.has(selector)) {
			output.push(block);
			mySet.add(selector);
		}
	}
	return output;
}
